import { V3Record } from 'data/helpers/V3Record.js'

export const RouteSetOverview = V3Record('routeSetOverview', {
  parentType: null, // string
  parentId: null, // integer
  assets: {}, // JSON
  urls: null, // JSON
  routeIds: [],
  route_ids: [],
  tripIds: [],
  trip_ids: [],
  embedSettings: null, // JSON
  startPoints: [], // [JSON]
  updatedAt: null
})

// RegionalEmbedlet needs underscored troute_id arrays :/
const _defaultDeserialize = RouteSetOverview.deserialize
RouteSetOverview.deserialize = (fromRails) => {
  const rso = _defaultDeserialize(fromRails)
  return rso
    .set('route_ids', rso.routeIds)
    .set('trip_ids', rso.tripIds)
}
